import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "Location/";

const getLocationById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetLocationById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getLocations = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetLocations?clientId=' + id, constants.REQUIRE_INTERCEPTORS);

const saveLocation = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveLocation', model, constants.REQUIRE_INTERCEPTORS);

const deleteLocation = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteLocation?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getLocationById,
    getLocations,
    saveLocation,
    deleteLocation
}